import { z } from 'zod';

export const RefKnowledges = z.object({
  code: z.string(),
  referential_id: z.string().uuid(),
  knowledge_category_code: z.string(),
  name: z.string(),
  type: z.string(),
  environmental_transition: z.boolean(),
  digital_transition: z.boolean(),
  ogr_code: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type RefKnowledgesT = z.infer<typeof RefKnowledges>;

export const RefKnowledgesInsert = RefKnowledges.partial();

export type RefKnowledgesInsertT = z.infer<typeof RefKnowledgesInsert>;

export const RefKnowledgesUpdate = RefKnowledges.partial();

export type RefKnowledgesUpdateT = z.infer<typeof RefKnowledgesUpdate>;
